import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'start',
      component: () => import('@/views/StartView.vue')
    },
    {
      path: '/gra',
      name: 'game',
      component: () => import('@/views/GameView.vue')
    },
    {
      path: '/jak-grac',
      name: 'how-to',
      component: () => import('@/views/HowToView.vue')
    },
    {
      path: '/hall-of-fame',
      name: 'hall-of-fame',
      component: () => import('@/views/HallOfFameView.vue')
    },
    {
      path: '/wynik',
      name: 'result',
      component: () => import('@/views/ResultView.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ],
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router